import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

class Hero {
    constructor(el) {
        if (!this.set(el)) return;
        
        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' && !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }

    set(el) {
        if (!el) return true;

        this.root = el;
        this.timerEl = this.root.querySelectorAll('[data-hero-timer-item]');
        this.bgSliderEl = this.root.querySelector('[data-hero-bg-slider]');
        this.mainSliderEl = this.root.querySelector('[data-hero-main-slider]');

        this.bgSwiper = null;
        this.mainSwiper = null;

        return true;
    }

    init() {
        this.setBgSwiper();
        this.setMainSwiper();
    }

    setBgSwiper() {
        if (!this.bgSliderEl) return;

        this.bgSwiper = new Swiper(this.bgSliderEl, {
            slidesPerView: 'auto',
            modules: [Autoplay],
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
        });

        this.setTimer();
    }

    setMainSwiper() {
        if (!this.mainSliderEl) return;

        this.mainSwiper = new Swiper(this.mainSliderEl, {
            slidesPerView: 'auto',
            modules: [Autoplay, EffectFade],
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });

        this.mainSwiper.on('slideChange', swiper => {
            const { realIndex } = swiper;
            this.bgSwiper.slideTo(realIndex);
        });
    }

    setTimer() {
        if (!this.bgSwiper) return;

        this.bgSwiper.on('slideChange', swiper => {
            const { realIndex } = swiper;
            this.setActiveTimer(realIndex);
        });

        this.timerEl.forEach(item => {
            item.addEventListener('click', event => this.onNavClick(event));
        });
    }

    setActiveTimer(index) {
        if (!this.timerEl) return;

        const timer = this.root.querySelector(
            `[data-hero-timer-item="${index}"]`
        );
        this.timerEl.forEach(item => item.classList.remove('active'));

        if (timer) timer.classList.add('active');
    }

    onNavClick(event) {
        const { currentTarget } = event;
        let index = currentTarget.getAttribute('data-hero-timer-item');
        if (!index) return;

        index = parseInt(index);
        this.mainSwiper.slideToLoop(index);
        this.bgSwiper.slideToLoop(index);

        this.mainSwiper.update();
        this.bgSwiper.update();
    }
}

const initHero = () => {
    const sections = document.querySelectorAll('[data-hero]');
    if (sections) sections.forEach(item => new Hero(item));
};

initHero();
